
<template>
  <!--新增分类-->
  <x-addEdit
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import mixin from '../../js/mixins';
import empty from '../../js/empty';
export default {
  mixins: [mixin.fetchSelect],
  name: 'aadCategory',
  data () {
    let decoratorOptions = {
      title: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入类目名称' },
          { pattern: this.REG.name, message: this.MESSAGE.name }
        ]
      },
      parent_id: { rules: [] },
      mark: {
        validateTrigger: 'blur',
        rules: [{pattern: this.REG.code, message: this.MESSAGE.code}]
      },
      images_id: { rules: [] },
      description: { rules: [{ min: 2, max: 20, message: '描述为2-20个字' }] },
      status: { initialValue: 1, rules: [] }
    };
    return {
      formList: [
        {
          label: '类目名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入类目名称',
          props: ['title', decoratorOptions.title]
        },
        {
          label: '上级类目',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择上级类目',
          changeOnSelect: true,
          disabled: false,
          fieldNames: {label: 'title', value: 'category_id', children: 'children'},
          props: ['parent_id', decoratorOptions.parent_id]
        },
        {
          label: '标识符',
          inputType: 'input',
          options: [],
          placeholder: '请输入标识符',
          disabled: false,
          props: ['mark', decoratorOptions.mark]
        },
        {
          label: '图标',
          inputType: 'upload',
          options: [],
          placeholder: '',
          name: 'images_id',
          resUrl: 'images_url',
          resName: 'file_name',
          fileList: [],
          uploadParam: {
            action: this.$store.state.uploadUrl,
            headers: {},
            accept: this.$store.state.imgAccept,
            listType: 'picture'
          },
          props: ['images_id', decoratorOptions.images_id]
        },
        {
          label: '描述',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入描述',
          props: ['description', decoratorOptions.description]
        },
        {
          label: '状态',
          inputType: 'radioGroup',
          options: this.$store.state.statusList,
          placeholder: '',
          props: ['status', decoratorOptions.status]
        }
      ],
      formKey: {
        title: '',
        parent_id: '',
        mark: '',
        images_id: '',
        description: '',
        status: ''
      },
      addParam: {
        url: '/category/product/',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/category/product/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/category/product/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    this.setApiUrl();
    if (this.$route.query.parentId) {
      this.formList[1].disabled = true;
      this.getSelect();
    }
    !this.$route.query.id && this.getSelect();
  },
  methods: {
    getSelect (parentId) {
      this.$get({
        url: '/select_list/devices_manage_list',
        params: {
          category_module: this.$store.state.categoryAddModule[this.$route.name],
          children_number: 2
        }
      }).then(({data}) => {
        if (parentId) {
          let startIndex = parentId.length;
          data.category.forEach((el) => {
            let num = 0;
            startIndex === num && (el.disabled = true);

            el.children && el.children.forEach((item) => {
              let num = 1;
              startIndex === num && (item.disabled = true);

              item.children && item.children.forEach((part) => {
                let num = 2;
                startIndex === num && (part.disabled = true);
              });
            });
          });
        }
        this.formList[1].options = data.category;
        if (this.$route.query.parentId) {
          empty.$emit('setForm', {'parent_id': this.$route.query.parentId});
        }
      });
    },
    setApiUrl () {
      let arr = ['addParam', 'editParam', 'detailParam'];
      arr.forEach((el) => {
        this[el].url = this.$store.state.categoryAddApi[this.$route.name];
      });
    },
    detailResHandle (data) {
      if (data.mark) {
        this.formList[2].disabled = true;
      }
      this.getSelect(data.parent_id);
      return {};
    },
    reqHandle (param) {
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/package/pageCompo/addCategory.vue